import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { NavigationService } from '@services/support/navigation.service';
import { Subscription, fromEvent, combineLatest } from 'rxjs';
import { auditTime, first } from 'rxjs/operators';
import { AuthService } from '@services/auth.service';
import { Router } from '@angular/router';
import { LoaderService } from '@services/support/loader.service';
import { DetailPageService } from '@services/support/detail-page.service';
import { ThirdPartiesService } from '@services/third-parties.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

  @ViewChild("detailContainer", { read: ViewContainerRef, static: true }) detailContainer: ViewContainerRef;

  sidebarOpen: boolean = false;
  sidebarSub: Subscription = null;
  resizeSub: Subscription = null;

  isDataLoaded: boolean = false;
  authSubscription: Subscription = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private detailPageService: DetailPageService,
    private navigationService: NavigationService,
    public loaderService: LoaderService,

    // Injected for bootstrap purposes
    private thirdPartiesService: ThirdPartiesService
  ) {
    this.sidebarSub = this.navigationService.sidebarState.subscribe(state => {
      this.sidebarOpen = state;
    });
  }

  ngOnInit() {
    this.detailPageService.setDetailContainer(this.detailContainer);

    this.authSubscription = this.authService.getAuth().subscribe(auth => {
      if (!auth) {
        this.router.navigate(['/login']);
      }
    });

    this.authService.user.pipe(first()).toPromise().then(() => {
      this.isDataLoaded = true;
    });

    if (window.innerWidth > 768) {
      this.navigationService.openSidebar();
    }

    this.resizeSub = fromEvent(window, "resize").pipe(auditTime(100)).subscribe(event => {
      if (window.innerWidth > 768) {
        if (!this.sidebarOpen)
          this.navigationService.openSidebar();
      } else {
        if (this.sidebarOpen)
          this.navigationService.closeSidebar();
      }
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) { this.authSubscription.unsubscribe() }
  }

  toggleSidebar() {
    this.navigationService.toggleSidebar();
  }
}
